module.exports = __webpack_public_path__ + "static/media/YelliyhDashboard.29348153.PNG";